import { hotResources } from '@/mocks/home';

export default function HotResources() {
  return (
    <section id="hot" className="bg-background-100 border-t border-foreground-950/10 scroll-mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-center gap-4">
          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-label">
            <i className="ri-fire-fill" />
          </span>
          <div>
            <p className="text-xs tracking-[0.25em] text-accent-700 font-label">FEATURED · 热门资源</p>
            <h2 className="mt-1.5 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              本周热度最高的小电影资源
            </h2>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-10">
          {hotResources.map((item, idx) => (
            <article
              key={item.id}
              className="flex items-start gap-4 py-5 border-b border-foreground-950/10 hover:bg-background-50/70 transition-colors px-1"
            >
              <span className="w-9 shrink-0 font-heading font-bold text-2xl text-foreground-200">
                {String(idx + 1).padStart(2, '0')}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                    {item.title}
                  </h3>
                  {item.badge && (
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 border border-accent-200 whitespace-nowrap">
                      {item.badge}
                    </span>
                  )}
                </div>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  <span className="text-primary-600">{item.type}</span>
                  <span className="w-px h-3 bg-foreground-950/15" />
                  <span>{item.meta}</span>
                </div>
              </div>

              <div className="shrink-0 text-right">
                <div className="font-heading font-bold text-lg text-primary-600">{item.heat}</div>
                <div className="text-[11px] text-foreground-400 font-label">热度</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}